import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import DeleteModal from "components/Common/DeleteModal"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from 'store/adminFilter/actions'
import { Link } from 'react-router-dom'
import { salesDeveloperPrefix } from 'configs/routePrefix'
 
const CardItem = ({ index, item, Service, updateHandler, setShouldGetData }) => {
    const status = item.status
    const [deleteModal, setDeleteModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [itemStatus, setItemStatus] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const service = new Service
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]
    const dispatch = useDispatch()

    useEffect(() => {
        setItemStatus(status)
    }, [status])

    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }
    const changeStatus = (e) => {
        setLoading(true)
        const value = e.target.checked
        service.toggleStatus(item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                setItemStatus(value)
                toast.success("Status updated successfully")
                setLoading(false)
                setTimeout(() => {
                    setShouldGetData(true)
                }, 1000)
            }
        })
    }

    return (
        <>
            <tr key={index}>
                <td className='font-size-13'>{item?.id}</td>
                <td className='font-size-13' style={{fontWeight: 700 }}>
                    <Link to={`${salesDeveloperPrefix}/property`} onClick={()=> {
                        localStorage.setItem('building_id', item?.id)
                        dispatch(appendFilters({building_id: item?.id}))
                        }}>
                        {item.name ?.en}
                    </Link>
                </td>
                <td className='font-size-13'>{item?.floors_num}</td>
                <td className='font-size-13'>{item?.available_units_count}</td>
                <td className='font-size-13'>{item?.bought_units_count}</td>
                <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                disabled={!isExist('edit_compound')}
                            />
                        </div>
                    </form>
                </td>
                <td className="removebtnhover">
                    {( isExist('delete_compound') || isExist('edit_compound')) &&<Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            {isExist('edit_compound') &&<DropdownItem onClick={updateHandler}>Edit</DropdownItem>}
                            {isExist('delete_compound') && <DropdownItem className="text-danger" onClick={() => {
                                    setDeleteModal(!deleteModal)
                                }}>Remove Building</DropdownItem>}
                        </DropdownMenu>
                    </Dropdown>}
                </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
        </>

    )
}

export default CardItem